import { Action } from '@ngrx/store';

export const ACTIVATE_LOADING = '[UI Loading] Loading...';
export const DEACTIVATE_LOADING = '[UI Loading] Done loading...';
export const ADD_ACTION = '[UI actions] Add...';
export const REMOVE_ACTION = '[UI actions] Remove...';
export class ActivateLoadingAction implements Action {
    readonly type = ACTIVATE_LOADING;
}

export class DeactivateLoadingAction implements Action {
    readonly type = DEACTIVATE_LOADING;
    constructor ( public payload?: string ) {}
}

export class Add {
  readonly type = ADD_ACTION;
  constructor(public payload: string) { }
}

export class Remove {
  readonly type = REMOVE_ACTION;
  constructor(public payload: string) {}
}
export type uiActions = ActivateLoadingAction | DeactivateLoadingAction | Add | Remove;
